import * as req from 'api/actions';
import * as c from './constant';

export const getOptionCalculationList = (id, payload, callback) =>
  req.list(
    c.GET_OPTION_CALCULATION_LIST,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_options`,
    payload,
    callback
  );

export const optionCalculationInfo = (id, payload, callback) =>
  req.item(
    c.OPTION_CALCULATION_INFO,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_options`,
    payload,
    callback
  );

export const createOptionFees = (id, payload, callback) =>
  req.create(
    c.CREATE_OPTION_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_options`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeOptionFees = (id, newOtherFeesId, payload, callback) =>
  req.remove(
    c.REMOVE_OPTION_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_options/${id}`,
    payload,
    callback
  );

export const updateOptionFees = (id, newOtherFeesId, payload, callback) =>
  req.update(
    c.UPDATE_OPTION_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_options/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getNewOtherFeesList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_NEW_OTHER_FEES,
    '/api/v1/bpls/administrator/tax_revenue/other_fees',
    payload,
    callback
  );

export const getSingleNewOtherFees = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_NEW_OTHER_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}`,
    payload,
    callback
  );